import OsagoKprMultiplierForm from './OsagoKprMultiplierForm';
import OsagoKprMultiplierList from './OsagoKprMultiplierList';

export default { OsagoKprMultiplierList, OsagoKprMultiplierForm };
